import { AppSocket } from "@/data/dao/socket/AppSocket";

let appSocket = new AppSocket();
export default function useAppSocket(options?: { createNewInstance: boolean }) {
    if (options?.createNewInstance) {
        appSocket?.dispose();
        appSocket?.disconnect();
        appSocket = new AppSocket();
    }

    return {
        appSocket,
    };
}
